<template>
  <div id="card" @click="viewPost">
    <template v-if="post.fetched">
      <div id="part1">
        <b id="title">{{post.title}}</b>
        <br class="part1-sep">
        <span id="author">{{post.by}}</span>
        <span id="time">{{formattedDate}}</span>
        <span v-if="num" id="num">{{num.toString(16)}}</span>
        <br class="part1-sep">
        <div id="link">
          <a
            v-if="urlPreview"
            :href="this.post.url"
            @click.stop
          >
            {{urlPreview}}
          </a>
        </div>
      </div>
      <div id="part2">
        <div>
          <img src="@/assets/upvote.png" height="20px" alt="upvotes">
          {{post.score}}
        </div>
        <br id="part2-sep">
        <div>
          <img src="@/assets/comments.png" height="20px" alt="comments">
          {{post.descendants}}
        </div>
      </div>
    </template>
    <template v-else>
      <svg height="60px" width="100%">
        <rect x="1%" y="10" rx="5" ry="5" width="80%" height="10" fill="#e0e0e0" />
        <rect x="1%" y="31.5" rx="3" ry="3" width="10%" height="7" fill="#e0e0e0" />
        <rect x="150px" y="31.5" rx="3" ry="3" width="30%" height="7" fill="#e0e0e0" />
        <rect x="1%" y="50" rx="3" ry="3" width="40%" height="7" fill="#e0e0e0" />
      </svg>
    </template>
  </div>
</template>

<script>
import { simplifyURL } from '@/util'

export default {
  name: 'PostPreview',
  props: {
    post: {
      type: Object,
      required: true
    },
    num: {
      type: Number,
      required: false
    }
  },
  methods: {
    viewPost () {
      if (this.post.fetched) {
        this.$router.push(`/post/${this.post.id}`)
      }
    }
  },
  computed: {
    urlPreview () {
      return simplifyURL(this.post.url)
    },
    formattedDate () {
      const date = new Date(this.post.time * 1000)
      const hours = date.getHours().toString()

      let minutes = date.getMinutes().toString()
      if (minutes.length === 1) minutes = '0' + minutes

      return `${hours}:${minutes} ${date.toDateString()}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/theme";
#card {
  border: 1px solid #8f8f8f;
  width: 80%;
  margin: 8px 0;
  padding: 10px;
  background-color: white;
  user-select: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  * {
    margin: 0;
  }

  &:hover {
    background-color: whitesmoke;
    cursor: pointer;
  }
}

#title {
  font-size: 20px;
}

#author {
  display: inline-block;
  width: 150px;
}

#time, #author, #num {
  font-size: 16px;
}

#link {
  font-size: 14px;
}

#part1, #part2 {
  font-size: 20px;
  align-self: center;
}

#part2 > div {
  white-space: nowrap;
  display: inline-block;
  margin: 0 5px;
}

#num {
  margin-left: 10px;
}

@media (max-width: $small-max), (min-width: $big-min) {
  #card {
    flex-direction: column;
  }

  #part1 {
    display: flex;
    flex-direction: column;
    align-self: start;
  }

  #part2 {
    align-self: start;
  }

  .part1-sep {
    display: none;
  }

  #part2-sep {
    display: none
  }

  #author {
    width: auto;
    order: 1;
  }

  #title {
    order: 0;
  }

  #link {
    order: 2;
    display: inline !important;
  }

  #time {
    order: 3;
  }

  #author, #link, #time, #part2 {
    margin: 12px 0 0 0;
  }
}

@media (max-width: $small-max) {
  #card {
    width: 90%;
  }

  #num {
    display: none
  }
}

@media (min-width: $med-min) and (max-width: $big-min - 1) {
  #card {
    width: $med-min * 0.8
  }
}

@media (min-width: $big-min) {
  #card {
    width: 400px;
    margin: 10px;
  }
  #link, #author, #time {
    font-size: 16px;
  }
  #title {
    font-size: 22px;
  }
}

</style>
